import { createAction } from '@ngrx/store';

export const viewedLandingModal = createAction(
  '[Product Details] Viewed Landing Modal'
);

export type LandingModalActions = typeof viewedLandingModal;
